import React from "react";
import Skeleton from "react-loading-skeleton";
import { ConfigurationPricingTotalFooter } from "./ConfigurationPricingTotalFooter";
import { DoorOptionsFooterProps } from "./DoorOptionsFooterMobile";
import { ZakelijkPriceDetails } from "./ZakelijkPriceDetails";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";

export const DoorOptionsFooterNormal: React.FC<DoorOptionsFooterProps> = ({
  selectedDoor,
  addToCart,
}) => {
  const productPrice = "€" + (selectedDoor?.price ?? 0).toFixed(2);
  const isProfielProduct = zakelijkProfielCodes.includes(
    selectedDoor?.code ?? "",
  );
  return (
    <>
      <div className="gg-grid gg-h-[115px] gg-w-full gg-border-t-2 gg-border-gray-200 gg-bg-gray-50">
        {/* First row */}
        <div className="gg-flex gg-w-full gg-flex-row gg-justify-between gg-px-8 xl:gg-px-12 2xl:gg-px-16">
          {/* LEFT SIDE */}
          <div className="gg-flex gg-items-center gg-space-x-5 xl:gg-space-x-12">
            {/* Product name */}
            <div className="gg-flex gg-items-center gg-py-4">
              {/* Selected standard product name */}
              <h1 className="gg-self-center gg-pr-2 gg-text-lg gg-font-bold gg-text-slate-800 2xl:gg-text-xl">
                {selectedDoor ? selectedDoor?.name : <Skeleton width={90} />}
              </h1>
              {!isProfielProduct && (
                <p className="gg-mt-0.5 gg-text-base gg-text-purple-300">
                  {productPrice}
                </p>
              )}
            </div>

            {/* Product details */}
            <ZakelijkPriceDetails selectedDoorCode={selectedDoor?.code} />
          </div>
          {/* LEFT SIDE END */}

          {/* RIGHT SIDE */}
          <div className="gg-flex gg-items-center gg-space-x-5 xl:gg-space-x-10">
            <ConfigurationPricingTotalFooter selectedDoor={selectedDoor} />

            {/* Buttons */}
            <div className="gg-flex gg-items-center gg-space-x-2.5 xl:gg-space-x-3">
              {/* add to cart */}

              <button
                type="button"
                onClick={() => addToCart()}
                data-testid="add-to-cart"
                className="gg-justify-center gg-rounded-sm gg-bg-yellow-300 gg-px-4 gg-py-3.5 gg-text-base gg-font-bold gg-text-dark-blue hover:gg-bg-yellow-400 hover:gg-text-zinc-900 xl:gg-px-7 xl:gg-py-4 2xl:gg-px-9"
              >
                In winkelmand
              </button>
            </div>
          </div>
        </div>
        {/* First row end */}
      </div>
    </>
  );
};
